import { Trans } from '@lingui/react/macro';

export const Copyright = () => (
  <div
    className="mobile-footer-copyright"
    style={{
      width: '96%',
      textAlign: 'left',
      margin: '0 2%',
      fontWeight: '200',
      fontSize: '14px',
    }}
  >
    <Trans>&copy; 2025 ProfAI, All Rights Reserved</Trans>
  </div>
);
